import React, { useState } from "react";
import { BackgroundGradient } from "../components/ui/background-gradient";
import { PlaceholdersAndVanishInput } from "../components/ui/placeholders-and-vanish-input";
import { Link } from "react-router-dom";
import { forgotPassword } from "apicalls/usersApiCall";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import rsbgLogo from "../data/rsbgloballogo.jpg";





export function ForgotPassword() {

    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);


    const placeholders = [
        "Email address should be valid",
        "Valid format: rajeev@rsbglobal.com",
        "Domain name should be valid",
        "Domain names like .com, .net, .org, etc. are valid",
    ];

    const handleChange = (e) => {
        setEmail(e.target.value);
    };


    const onSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            email: email
        }

        if (email.length > 0 && email.includes("@") && email.includes(".") && email.includes("com")) {
            setIsButtonDisabled(false);
            const response = await forgotPassword(payload);

            if (response?.success) {
                message.success(response?.message);
                navigate("/login");
            } else {
                message.error(response?.message);
                return;
            }
        } else {
            message.error("Invalid email address");
            setIsButtonDisabled(true);
            return;
        }



    };

    return (
        <div className="min-h-screen w-full bg-neutral-950 relative flex flex-col items-center justify-center antialiased overflow-hidden">
            <div className="max-w-2xl mx-auto p-4 sm:p-6 md:p-8 relative z-10">
                {/* Logos */}
                <div className="flex justify-center items-center gap-4 mb-6">
                    <div className="w-60 h-16 bg-gradient-to-tr from-blue-900 to-gray-900 rounded-2xl flex items-center justify-center shadow-lg p-2">
                        <img src={rsbgLogo} alt="Smartweld" className="w-full h-full object-contain" />
                    </div>
                </div>
                <h1 className="relative z-10 text-4xl sm:text-5xl md:text-7xl bg-clip-text text-transparent bg-gradient-to-b from-neutral-200 to-neutral-600 text-center font-sans font-bold mb-4">
                    Verify it's you
                </h1>
                <p className="text-neutral-500 max-w-lg mx-auto my-4 text-sm sm:text-base text-center relative z-10">
                    Enter your email to verify your account. On successful verification, you will receive a link to reset your password over the email you provided.
                </p>
                <div className="mt-8 sm:mt-10 relative z-10">
                    <PlaceholdersAndVanishInput
                        disabled={isButtonDisabled}
                        placeholders={placeholders}
                        onChange={handleChange}
                        onSubmit={onSubmit}
                    />
                </div>
                <div className="text-neutral-500 max-w-lg mx-auto my-4 text-sm sm:text-base text-center relative z-10">
                    <p className="text-sm font-medium text-gray-500">Have credentials?
                        <span className="text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"> <Link to="/login">
                            <button className="text-sm font-medium text-gray-600 hover:text-gray-700 transition-colors cursor-pointer bg-green-500 px-4 rounded-xl py-2 `">
                                Back to Login
                            </button>
                        </Link></span>

                    </p>
                </div>
            </div>
            <BackgroundGradient />
        </div>
    );
}
